import React from 'react';

import { isBrowser } from '../../../helpers/is-browser';
import Button from '../../ui/button/button';
import { useIsMPLivliFamily } from '@/providers/ConfigProvider';

interface ShowMoreProps {
  currentPage: number;
  setPage: React.Dispatch<number>;
  maxNum: number;
  pageSize: number;
  showingString?: string;
  ofString?: string;
  showMoreString?: string;
  event?: string;
  user?: any;
}

export const ShowMore = ({
  currentPage,
  maxNum,
  setPage,
  pageSize,
  showingString,
  ofString,
  showMoreString,
  event,
  user,
}: ShowMoreProps) => {
  const isLivliFamily = useIsMPLivliFamily();
  const showMoreLineMaxWidth = 240;

  const curNum =
    currentPage * pageSize > maxNum ? maxNum : currentPage * pageSize;
  const curLineWidth = (curNum / maxNum) * showMoreLineMaxWidth;

  const sendGtmEvent = () => {
    if (isBrowser) {
      dataLayer.push({
        event: event,
        user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      });
    }
  };

  const showMoreButtonClickHandler = () => {
    setPage(currentPage + 1);
    if (event) sendGtmEvent();
  };

  return (
    <div className="mt-12 flex flex-col items-center">
      <div className="text-bodym">{`${showingString} ${curNum} ${ofString} ${maxNum}`}</div>
      <div className="relative mb-6 mt-3 h-[2px] w-[240px] bg-brand-grey-2">
        <div
          style={{
            width: isNaN(curLineWidth)
              ? `${showMoreLineMaxWidth}px`
              : `${curLineWidth}px`,
          }}
          className="absolute left-0 top-0 z-10 h-[2px] bg-brand-grey-4"
        ></div>
      </div>
      {curNum < maxNum && (
        <Button
          variant="secondary"
          size="small"
          onClick={showMoreButtonClickHandler}
        >
          {showMoreString}
        </Button>
      )}
    </div>
  );
};

export default ShowMore;
